module.exports = "/_next/static/media/4e95b42f6c55d0fe0c1836d0e51fab5a.svg";